<template>
    <div class="drawer-disclaimer">
        <p>Da oggi puoi disegnare più aree contemporaneamente su mappa, per identificare le zone di tuo interesse!</p>
        <img :src="'/img/icons/' + $root.network + '/multi.svg'" class="multi" />
    </div>
</template>

<script>
import VueCookies from 'vue-cookies'

export default {
    mounted() {
        $cookies.set('drawer_disclaimer_shown', true)
    },
}
</script>